import { bool, node, shape } from 'prop-types'
import { Component } from 'react'

import { isDesktop, isMobile, isTablet } from 'shared/utils/deviceClassUtils'
import { type InferPropsWithDefaults } from 'shared/utils/propTypes'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { publicRuntimeConfigType } from 'views/utils/propTypes'

class Device extends Component<ComponentProps> {
  constructor(props: ComponentProps) {
    super(props)

    const { desktop, tablet, mobile } = props

    if (![desktop, tablet, mobile].some(Boolean)) {
      throw new Error('Device: One of the types should be provided')
    }
  }

  shouldRender(): boolean {
    const {
      publicRuntimeConfig: {
        publicConfig: { deviceClass },
      },
      mobile,
      desktop,
      tablet,
    } = this.props

    if (mobile && isMobile(deviceClass)) {
      return true
    }
    if (tablet && isTablet(deviceClass)) {
      return true
    }
    if (desktop && isDesktop(deviceClass)) {
      return true
    }

    return false
  }

  render() {
    return this.shouldRender() ? this.props.children : null
  }
}

const propTypes = {
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  children: node,
  desktop: bool,
  mobile: bool,
  tablet: bool,
}

const defaultProps = {
  children: null,
  desktop: false,
  tablet: false,
  mobile: false,
}

type ComponentProps = InferPropsWithDefaults<
  typeof propTypes,
  typeof defaultProps
>

export default withShopAndRuntimeConfig(Device)
